import React, { Component } from "react";
import { Link } from "react-router-dom";
// get our fontawesome imports
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class Footer extends Component {
  constructor() {
    super();
    this.state = {
      msg: null,
      type: null,
      flash: false,
      alert: null,
    };
  }

  scriptJs() {
    // NAVBAR EFFECT
    window.onscroll = function () {
      myNavbar();
      scrollFunction();
    };
    function myNavbar() {
      var x = document.getElementById("myNav");
      if (
        document.body.scrollTop > 50 ||
        document.documentElement.scrollTop > 50
      ) {
        x.classList.add("shadow-sm");
        x.classList.add("bg-white-50");
        x.classList.remove("pt-4");
        x.classList.remove("bg-transparent");
      } else {
        x.classList.remove("shadow-sm");
        x.classList.remove("bg-white-50");
        x.classList.add("pt-4");
        x.classList.add("bg-transparent");
      }
    }
    // END NAVBAR EFFECT

    function scrollFunction() {
      var mybutton = document.getElementById("myBtn");
      if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
      ) {
        mybutton.classList.add("d-block");
        mybutton.classList.remove("d-none");
      } else {
        mybutton.classList.add("d-none");
        mybutton.classList.remove("d-block");
      }
    }
  }

  scrollTopButton() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  render() {
    return (
      <div>
        <button
          className="btn btn-light fixed-button d-none m-3 fs-4 px-3 py-1 shadow"
          onClick={() => this.scrollTopButton()}
          id="myBtn"
          title="Go to top"
        >
          <FontAwesomeIcon icon={faChevronUp} />
        </button>
        {this.scriptJs()}
      </div>
    );
  }
}

export default Footer;
